module.exports = __webpack_public_path__ + "img/logo_icon.316357ae.png";